module.exports = __webpack_public_path__ + "themes/fq/sprite/win-sign.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/win-sign.png
// module id = 75
// module chunks = d-game